import {State} from "../../../store";
import {TypedUseSelectorHook, useSelector as useBaseSelector} from "react-redux";

const useSelector: TypedUseSelectorHook<State> = useBaseSelector;

export default useSelector;